








































import Vue from 'vue'
import CastBadge from '@/components/CastBadge'
import { SupportLevel } from '@/types/casts'

export default Vue.extend({
  name: 'CastSupportBadge',
  props: {
    support: String,
    pending: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    supportLabel (): String {

      switch (this.support) {
        case SupportLevel.Platinum:
          return (this.pending) ? 'Pending' : 'Platinum'
        case SupportLevel.Gold:
          return 'Gold'
        case SupportLevel.Silver:
          return 'Silver'
        case SupportLevel.Lite:
          return 'Lite'
        default:
          return 'Silver'
      }

    },
    className (): String {

      const list: String[] = []

      if (this.pending) list.push('badge--pending')
      if (this.support) list.push(`badge--${ this.support }`)

      return list.join(' ')

    }
  },
  components: {
    CastBadge
  }
})

